import React from 'react'
import MainLayout from '@layouts/main-layout'
import FlashSale from '@components/flash-sale'

const FlashsalePage = () => {
  return (
    <>
      <FlashSale />
    </>
  )
}

FlashsalePage.getLayout = (page: React.ReactElement) => {
  return <MainLayout>{page}</MainLayout>
}

export default FlashsalePage
